import { Button } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { useCustomParamId } from 'hooks/useParamId';
import { useTranslation } from 'react-i18next';
import {
  useGetChannelAssetIdListInfinite,
  usePostChannelAssetId,
} from 'services/channel/assetId';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';
import PopupForm from '../form/PopupForm';

const AssetIdPopupForm = () => {
  const { t } = useTranslation();

  const createAssetId = usePostChannelAssetId();

  const channelId = useCustomParamId('id');
  const videoId = useCustomParamId('videoId');

  const assets = useGetChannelAssetIdListInfinite({
    channelId,
    videoId: videoId.length ? videoId : undefined,
  });

  return (
    <PopupForm
      header={t('button.create-what', { what: 'asset ID' })}
      initialValues={{ assetId: '' }}
      trigger={
        <Button>
          <Button.Text text={t('button.add')} />
        </Button>
      }
      onSubmit={async (values, helpers, actions) =>
        await createAssetId.mutateAsync(
          {
            assetId: values.assetId,
            channelId: channelId,
            videoId: videoId.length ? videoId : null,
          },
          {
            onSuccess: () => {
              actions?.close();
              assets.refetch();
            },
            onError: error => onErrorShowAllErrorsToast(error),
          }
        )
      }>
      <FormInput.Text name='assetId' label='Asset ID' />
    </PopupForm>
  );
};

export default AssetIdPopupForm;
